import React from "react";
import { toast } from "react-hot-toast";

/**
 * WhatsApp Channels have no official posting API (Cloud API does not expose Channels),
 * so we give the admin one-tap copy/share of channel-ready text + image.
 */
export const ChannelShareButtons: React.FC<{ text: string; imageUrl?: string | null }> = ({ text, imageUrl }) => {
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(text);
      toast.success("Copied. Open the Ruchira channel in WhatsApp and paste.");
    } catch {
      window.prompt("Copy this text:", text);
    }
  };

  const share = async () => {
    const nav: any = navigator;
    try {
      if (imageUrl && nav.canShare) {
        const blob = await fetch(imageUrl).then((r) => (r.ok ? r.blob() : Promise.reject()));
        const file = new File([blob], "ruchira-special.jpg", { type: blob.type || "image/jpeg" });
        if (nav.canShare({ files: [file] })) {
          await nav.share({ files: [file], text });
          return;
        }
      }
      if (nav.share) {
        await nav.share({ text });
        return;
      }
    } catch (e: any) {
      if (e?.name === "AbortError") return;
    }
    window.open(`https://wa.me/?text=${encodeURIComponent(text)}`, "_blank", "noopener");
  };

  return (
    <div className="flex flex-wrap gap-2">
      <button type="button" onClick={copy} className="px-3 py-2 rounded-lg border text-sm font-semibold bg-white hover:bg-gray-50">
        📋 Copy for Channel
      </button>
      <button type="button" onClick={share} className="px-3 py-2 rounded-lg text-sm font-semibold bg-green-600 text-white hover:bg-green-700">
        📤 Share to WhatsApp{imageUrl ? " (with image)" : ""}
      </button>
      <a
        href={`https://wa.me/?text=${encodeURIComponent(text)}`}
        target="_blank"
        rel="noopener noreferrer"
        className="px-3 py-2 rounded-lg border text-sm font-semibold bg-white hover:bg-gray-50"
      >
        Open WhatsApp
      </a>
      {imageUrl && (
        <a href={imageUrl} target="_blank" rel="noopener noreferrer" download className="px-3 py-2 rounded-lg border text-sm font-semibold bg-white hover:bg-gray-50">
          🖼️ Image
        </a>
      )}
    </div>
  );
};
